<template>
  <footer class="theme-footer-five mt-130 md-mt-100">
    <div class="inner-container">
      <div class="container">
        <div class="footer-aligned-section d-flex flex-column gap-4">
          <!-- Responsive Layout: desktop side-by-side, mobile stacked -->
          <div class="footer-responsive-wrapper">
            <!-- Left Block: Help -->
            <div class="footer-col footer-col-left">
              <h4 class="footer-section-title mb-0">{{ $t('footer.helpTitle') }}</h4>
              <p class="footer-help-text mt-2">
                {{ $t('footer.use') }}
                <router-link
                    to="#contactModal"
                    data-bs-toggle="modal"
                    data-bs-target="#contactModal"
                    class="footer-link"
                >
                  {{ $t('footer.contactForm') }}
                </router-link>
                {{ $t('footer.orWrite') }}
                <a href="mailto:support@saasconstruct.com" class="footer-link">
                  {{ $t('footer.supportEmail') }}
                </a>
              </p>
              <div class="d-flex align-items-center justify-content-center justify-content-md-center follow-container">
                <p class="footer-follow mb-0 me-2">{{ $t('footer.followSocial') }}</p>
                <a href="https://x.com/@server_kota" target="_blank">
                  <img
                      src="../../assets/images/icon/social_icons/x.svg"
                      alt="X / Twitter"
                      width="22"
                      height="22"
                  />
                </a>
              </div>
            </div>

            <!-- Right Block: Newsletter -->
            <div class="footer-col footer-col-right mt-4 mt-md-0 newsletter-container">
              <h2 class="newsletter-title mb-0">{{ $t('newsletter.title') }}</h2>
              <p class="newsletter-description mt-2 mb-0">
                {{ $t('newsletter.description') }}
              </p>
              <div class="iframe-container mt-30">
                <iframe
                    src="https://embeds.beehiiv.com/8056421e-7832-4b6b-8a8b-5a68f9fa5980?slim=true"
                    data-test-id="beehiiv-embed"
                    height="60"
                    frameborder="0"
                    scrolling="no"
                    class="newsletter-iframe"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ContactModal />
    </div>

    <!-- Footer Links -->
    <div class="container about-company mt-5">
      <div class="row justify-content-center align-items-start text-start">
        <div class="col-6 col-lg-4 d-flex flex-column align-items-center">
          <div class="title-about-company">{{ $t('footer.legalTitle') }}</div>
          <div class="text-center w-100">
            <router-link to="/terms">{{ $t('footer.terms') }}</router-link>
          </div>
          <div class="text-center w-100">
            <router-link to="/privacy">{{ $t('footer.privacy') }}</router-link>
          </div>
        </div>

        <div class="col-6 col-lg-4 d-flex flex-column align-items-center">
          <div class="title-about-company">{{ $t('footer.companyTitle') }}</div>
          <div class="text-center w-100">
            <router-link to="/about">{{ $t('footer.about') }}</router-link>
          </div>
          <div class="text-center w-100">
            <router-link to="/">{{ $t('footer.home') }}</router-link>
          </div>
        </div>

        <div class="col-6 col-lg-4 d-flex flex-column align-items-center">
          <div class="title-about-company">{{ $t('footer.links') }}</div>
          <div class="text-center w-100">
            <a
                href="https://saasconstruct.lemonsqueezy.com/affiliates"
                target="_blank"
                rel="noopener"
                style="font-size: 17px; text-decoration: underline;"

            >
              {{ $t('footer.affiliate') }}
            </a>
          </div>
        </div>
      </div>
    </div>



    <div class="text-center mt-35"><BuiltWithButton /></div>
    <p class="copyright text-center">{{ $t('footer.copyright') }}</p>
  </footer>
</template>






<script>
import ContactModal from "../saas-infra-main/SaasInfraContactModal.vue";
import BuiltWithButton from "@/components/buttons/BuiltWithButton.vue";

export default {
  name: "SaasInfraFooter",
  components: {
    ContactModal,
    BuiltWithButton
  }
};
</script>

<style scoped>
.footer-aligned-section {
  margin-top: 48px;
  gap: 1rem;
}

.footer-responsive-wrapper {
  display: flex;
  flex-direction: column;
}

.footer-col {
  flex: 1;
  min-width: 280px;
  padding: 0 1rem;
  text-align: center;
}

.iframe-container {
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .footer-responsive-wrapper {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    text-align: center; /* ✅ keep center alignment */
  }

  .footer-col {
    max-width: 50%;
    text-align: center; /* ✅ make sure text stays centered */
  }

  .iframe-container {
    justify-content: center; /* ✅ center iframe as well */
  }

  .footer-col-left {
    padding-right: 2rem;
  }

  .footer-col-right {
    padding-left: 2rem;
  }
}


/* Headings */
.footer-section-title,
.newsletter-title {
  font-size: 1.2rem;
  font-weight: 600;
}

/* Paragraphs */
.footer-help-text,
.newsletter-description {
  font-size: 1rem;
  color: #444;
}

  @media (min-width: 1200px) {
    .follow-container {
      margin-top: 40px;
    }
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    .follow-container {
      margin-top: 40px;
    }
  }

  @media (min-width: 1023px) and (max-width: 993px)  {
    .follow-container {
      margin-top: 40px;
    }
  }

  @media (min-width: 992px) and (max-width: 1022px)  {
    .follow-container {
      margin-top: 40px;
    }
  }

  @media (min-width: 768px) and (max-width: 991px)  {
    .follow-container {
      margin-top: 40px;
    }
  }

  @media (max-width: 767px) {
    .follow-container {
      margin-top: 10px;
    }
  }

@media (max-width: 768px) {
  .newsletter-container {
    margin-bottom: 50px !important;
  }
}

.footer-follow {
  font-size: 1rem;
  font-weight: 500;
  color: #555;
}

.footer-link {
  color: #7736DC;
  text-decoration: underline;
}

.newsletter-iframe {
  width: 90%;
  max-width: 480px;
  border: none;
  align-self: center;
}

/* Footer bottom links */
.title-about-company {
  font-weight: 600;
  margin-bottom: 10px;
}

.footer-section-title,
.newsletter-title {
  font-size: 1.3rem;
  font-weight: 600;
}



</style>
